import '../styles/main.scss';
import './modules/burger';
document.addEventListener( 'DOMContentLoaded', function () {
	function handleLoader() {
		if ( window.innerWidth < 767 ) {
			setTimeout( () => {
				document.querySelector( '.loader-wrapper' ).style.display = 'none';
			}, 2500 );
		}
	}

	// Виконуємо при завантаженні
	handleLoader();

	// Оновлюємо при зміні розміру вікна
	window.addEventListener( 'resize', handleLoader );
} );
